import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { trackWhatsAppClick } from "@/lib/tracking";

const WA_LINK = `https://wa.me/919873362362?text=${encodeURIComponent("Hi DNA Digital, I'd like to talk about growing my D2C brand.")}`;

const WhatsappIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.372-.025-.521-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

export default function MobileCTABar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
          data-testid="mobile-cta-bar"
          className="lg:hidden fixed bottom-0 left-0 right-0 z-[65] px-4 pb-4 pt-3 bg-gradient-to-t from-[#FDFCF8] via-[#FDFCF8]/95 to-transparent"
        >
          <div className="flex items-center gap-3">
            <a
              href="#audit"
              data-testid="mobile-cta-audit"
              className="group flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-[#0A0A0A] px-6 py-4 text-white font-body font-semibold shadow-[0_12px_30px_-8px_rgba(0,0,0,0.5)]"
            >
              Get My Free Audit
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#F48220]">
                <ArrowUpRight className="h-4 w-4 text-black" />
              </span>
            </a>
            <a
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              onClick={trackWhatsAppClick}
              data-testid="mobile-cta-whatsapp"
              aria-label="Chat on WhatsApp"
              className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-[#25D366] shadow-[0_12px_30px_-8px_rgba(37,211,102,0.6)]"
            >
              <WhatsappIcon className="h-7 w-7 text-white" />
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
